var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CalculatorResult"},_vm._l((_vm.source),function(item){return _c('div',{key:item.code,staticClass:"item"},[_c('div',{staticClass:"left"},[_vm._v(_vm._s(item.name))]),(
        item.name == '项目' ||
          item.name == '首付比例' ||
          item.name == '年化利率'
      )?_c('div',{staticClass:"right"},[_vm._v(" "+_vm._s(item.value ? item.value + item.unit : "")+" ")]):_c('div',{staticClass:"right"},[_vm._v(" "+_vm._s(item.value ? Math.round(item.value) + item.unit : "")+" ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }